<a *ngIf="hasActiveCheckinInfo" class="nav-item indicator d-flex align-items-center" [routerLink]="[parkingRoute]">
  {{getIndicatorText}} <span class="ms-2 icon-time text-danger"></span>
</a>
